import type { CityConfig } from "@/pages/city-template/types";

export const jamestownConfig: CityConfig = {
  city: "Jamestown",
  state: "New York",
  stateAbbr: "NY",
  slug: "jamestown",
  route: "/cities/jamestown",
  title: "Emergency & Expedited Passport Jamestown NY | Same Day Passport Jamestown",
  metaDescription:
    "Emergency passport Jamestown NY — same day, 24-hour, and 3-5 day expedited passport processing for Chautauqua County. Fast Passport Center serves Jamestown, Dunkirk, Fredonia, and all Western New York communities.",
  h1: "Emergency & Expedited Passport Services in Jamestown, NY",
  heroSubtitle:
    "Jamestown's fast passport solution — from the Furniture Capital to the shores of Chautauqua Lake. Whether you're flying out of Buffalo Niagara or Erie, Fast Passport Center delivers emergency passports in as little as 24 hours and expedited processing in 3-5 days.",
  heroImageUrl:
    "https://readdy.ai/api/search-image?query=Jamestown%20New%20York%20skyline%20and%20downtown%20with%20Chautauqua%20Lake%20in%20the%20distance%2C%20historic%20city%20architecture%2C%20Lucille%20Ball%20hometown%20heritage%2C%20and%20rolling%20western%20New%20York%20hills%2C%20warm%20golden%20afternoon%20light%2C%20modern%20travel%20photography%20with%20clean%20composition%2C%20no%20text%20overlay%2C%20charming%20western%20New%20York%20small-town%20scene%20with%20lake%20and%20hills&width=1600&height=700&seq=ny-jamestown-hero-001&orientation=landscape",
  heroImageAlt: "Jamestown New York skyline with Chautauqua Lake in the distance and rolling western New York hills",
  geoPosition: "42.0970; -79.2353",
  geoPlacename: "Jamestown, New York, United States",
  lastModified: "2026-05-31",
  regionalAgency: {
    name: "New York Passport Agency",
    address: "376 Hudson Street, New York, NY 10014",
    distance: "~380 miles (Southeast in Manhattan)",
  },
  nearbyCitiesZips: [
    { name: "Jamestown", zips: "14701, 14702" },
    { name: "Dunkirk", zips: "14048" },
    { name: "Fredonia", zips: "14063" },
    { name: "Westfield", zips: "14787" },
    { name: "Lakewood", zips: "14750" },
    { name: "Bemus Point", zips: "14712" },
    { name: "Mayville", zips: "14757" },
    { name: "Silver Creek", zips: "14136" },
    { name: "Buffalo", zips: "14201-14204, 14206-14210, 14211-14214, 14215, 14216, 14217, 14218, 14219, 14220, 14221, 14222, 14223, 14224, 14225, 14226, 14227, 14228, 14231, 14233, 14240, 14241, 14260, 14261, 14263, 14264, 14265, 14267, 14269, 14270, 14272, 14273, 14276, 14280" },
    { name: "Erie, PA", zips: "16501, 16502, 16503, 16504, 16505, 16506, 16507, 16508, 16509, 16510, 16511, 16512, 16514, 16515, 16522, 16530, 16531, 16534, 16541, 16544, 16546, 16550, 16563, 16565" },
    { name: "Rochester", zips: "14602, 14603, 14604, 14605, 14606, 14607, 14608, 14609, 14610, 14611, 14612, 14613, 14614, 14615, 14616, 14617, 14618, 14619, 14620, 14621, 14622, 14623, 14624, 14625, 14626, 14627, 14642, 14650, 14652, 14653, 14692" },
    { name: "Syracuse", zips: "13201-13210, 13211, 13212, 13214, 13215, 13217, 13218, 13219, 13220, 13224, 13225, 13235, 13244, 13250, 13251, 13252, 13261, 13290" },
    { name: "Elmira", zips: "14901, 14902, 14903, 14904, 14905, 14925" },
    { name: "New York City", zips: "10001-10282, 11201-11251" },
  ],
  benefits: [
    {
      icon: "ri-time-line",
      title: "As Fast as 24 Hours",
      desc: "Emergency passport processing for Jamestown travelers with urgent departures — same day service available for documented emergencies.",
    },
    {
      icon: "ri-shield-check-line",
      title: "Registered Courier",
      desc: "U.S. Department of State registered passport courier with direct access to the New York Passport Agency.",
    },
    {
      icon: "ri-customer-service-2-line",
      title: "Real Human Support",
      desc: "Dedicated agents guide you through every step — no chatbots, no automated runaround. Available for Jamestown residents 7 days a week.",
    },
    {
      icon: "ri-map-pin-line",
      title: "Chautauqua & Western NY Region",
      desc: "Jamestown, Dunkirk, Fredonia, and all of Chautauqua County — we serve western New York and the Lake Erie region.",
    },
  ],
  testimonials: [
    {
      name: "Margaret H.",
      location: "Dunkirk, NY",
      rating: 5,
      text: "Had a family trip to Canada in 6 days. Fast Passport Center processed my expedited passport in 4 days. They even helped me figure out which Buffalo post office to visit for the acceptance clerk.",
      service: "Expedited Passport",
    },
    {
      name: "Thomas R.",
      location: "Fredonia, NY",
      rating: 5,
      text: "Renewed my expired passport through Fast Passport Center. The 5-day option was perfect for my upcoming trip to Ireland. Great communication throughout.",
      service: "Passport Renewal",
    },
    {
      name: "Catherine L.",
      location: "Jamestown, NY",
      rating: 5,
      text: "First-time passport for my daughter's study abroad program. Fast Passport Center helped us navigate the acceptance clerk process at the Jamestown post office.",
      service: "New Passport",
    },
  ],
  facilities: [
    {
      id: "jamestown-1",
      name: "Jamestown Main Post Office",
      type: "Post Office / Passport Acceptance Facility",
      address: "300 E 2nd Street",
      city: "Jamestown",
      state: "NY",
      zip: "14701",
      phone: "716-484-0104",
      hours: "Mon-Fri 8:30 AM - 5:00 PM, Sat 9:00 AM - 1:00 PM",
      distance: "Downtown Jamestown",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Jamestown passport acceptance facility. First-time applicants and those not eligible for mail-in renewal must apply in person.",
      icon: "ri-building-2-line",
    },
    {
      id: "jamestown-2",
      name: "Dunkirk Post Office",
      type: "Post Office / Passport Acceptance Facility",
      address: "120 E 2nd Street",
      city: "Dunkirk",
      state: "NY",
      zip: "14048",
      phone: "716-366-4470",
      hours: "Mon-Fri 9:00 AM - 5:00 PM, Sat 9:00 AM - 12:00 PM",
      distance: "Dunkirk (~30 miles north)",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Passport acceptance services available by appointment. Convenient for Dunkirk and Lake Erie shoreline residents.",
      icon: "ri-building-2-line",
    },
    {
      id: "jamestown-3",
      name: "Fredonia Post Office",
      type: "Post Office / Passport Acceptance Facility",
      address: "9 Temple Street",
      city: "Fredonia",
      state: "NY",
      zip: "14063",
      phone: "716-679-1094",
      hours: "Mon-Fri 9:00 AM - 5:00 PM, Sat 9:00 AM - 12:00 PM",
      distance: "Fredonia (~25 miles north)",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Passport acceptance services available. Serving Fredonia, SUNY Fredonia, and north Jamestown communities.",
      icon: "ri-building-2-line",
    },
  ],
  faqs: [
    {
      q: "How fast can I get an emergency passport in Jamestown?",
      a: "Fast Passport Center offers same-day emergency passport processing in as little as 24 hours for Jamestown residents with documented life-or-death emergencies. For urgent travel within 2 weeks, our 3-5 day expedited service is the most popular option. Standard processing through the post office takes 8-11 weeks.",
    },
    {
      q: "Where is the closest passport acceptance facility in Jamestown?",
      a: "The Jamestown Main Post Office at 300 E 2nd Street is the primary Jamestown passport acceptance facility. The Dunkirk Post Office at 120 E 2nd Street and Fredonia Post Office at 9 Temple Street are also convenient options. First-time applicants and those not eligible for mail-in renewal must apply in person.",
    },
    {
      q: "Can I get same-day passport photos in Jamestown?",
      a: "Yes — passport photos are available at CVS Pharmacy, Walgreens, and UPS Store locations throughout Jamestown, Dunkirk, and Fredonia. We also offer photo review as part of our service to ensure your 2x2 photos meet all State Department requirements.",
    },
    {
      q: "How much does an expedited passport cost in Jamestown?",
      a: "Government fees are set by the State Department and vary based on passport type (book vs card, large book option). Fast Passport Center's service fees depend on processing speed: 10-day Smart Saver, 3-5 day Expedited, or 24-hour Emergency. Call 877-253-0084 for a personalized quote based on your Jamestown passport needs.",
    },
    {
      q: "Do I need to visit the New York Passport Agency in person?",
      a: "No — if you use Fast Passport Center, you do not need to visit the New York Passport Agency in Manhattan. As a registered courier, we handle the agency submission for you. The only reason to visit the agency directly is for a documented life-or-death emergency, and appointments are extremely difficult to obtain.",
    },
    {
      q: "What is the fastest way to renew a passport in Jamestown?",
      a: "The fastest way to renew a passport in Jamestown is through Fast Passport Center's 3-5 day expedited service. If your most recent passport was issued when you were 16 or older, within the last 15 years, and is undamaged, you may qualify for renewal without an acceptance clerk visit. For even faster renewal, our 24-hour emergency service is available.",
    },
    {
      q: "Can I get a child passport expedited in Jamestown?",
      a: "Yes — Fast Passport Center expedites child passports for minors under 16 in Jamestown and all Chautauqua County communities. Both parents must appear with the child or provide notarized consent (Form DS-3053). We review all parental consent documentation before submission to avoid delays.",
    },
    {
      q: "Does Fast Passport Center have an office in Jamestown?",
      a: "Fast Passport Center operates as a remote courier service — we do not have a physical office in Jamestown. We serve the Furniture Capital and all of Chautauqua County through our secure overnight shipping and agency submission process. Our headquarters are in Washington, DC.",
    },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Jamestown", address: "various CVS locations across Jamestown, Dunkirk, and Fredonia", hours: "Mon-Sun, hours vary by location" },
    { name: "Walgreens — Jamestown", address: "various Walgreens locations throughout Jamestown and Chautauqua County", hours: "Mon-Sun, hours vary by location" },
    { name: "UPS Store — Jamestown", address: "various UPS Store locations in Jamestown area", hours: "Mon-Fri 9:00 AM - 7:00 PM, Sat 10:00 AM - 4:00 PM" },
    { name: "Walmart Photo Center — Jamestown", address: "Walmart locations in Jamestown and Dunkirk area", hours: "Mon-Sun 8:00 AM - 10:00 PM" },
  ],
  dmvLocations: [
    {
      name: "NYS DMV — Jamestown",
      address: "512 Falconer Street, Jamestown, NY 14701",
      hours: "Mon-Fri 8:30 AM - 4:00 PM",
      note: "Jamestown DMV office for license renewals and REAL ID applications. Accepts walk-ins but appointments are strongly recommended.",
      featured: true,
    },
    {
      name: "NYS DMV — Dunkirk",
      address: "309 Lake Shore Drive West, Dunkirk, NY 14048",
      hours: "Mon-Fri 8:30 AM - 4:00 PM",
      note: "Dunkirk DMV office for Chautauqua County residents. Alternative for Jamestown area residents.",
      featured: false,
    },
    {
      name: "NYS DMV — Fredonia",
      address: "11 Temple Street, Fredonia, NY 14063",
      hours: "Mon-Fri 8:30 AM - 4:00 PM",
      note: "Fredonia DMV office for SUNY Fredonia and north Chautauqua County residents.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "BUF",
      name: "Buffalo Niagara International Airport",
      distance: "~70 miles from Jamestown",
      address: "4200 Genesee Street, Buffalo, NY 14225",
      note: "Major international airport in Buffalo with direct flights to Europe and worldwide destinations. Primary airport for Jamestown and Chautauqua County travelers.",
      flightUrl: "https://www.buffaloairport.com/",
      flightLabel: "Buffalo Airport",
      featured: true,
    },
    {
      code: "ERI",
      name: "Erie International Airport",
      distance: "~40 miles from Jamestown (in PA)",
      address: "4411 W 12th Street, Erie, PA 16505",
      note: "Regional airport in Erie, Pennsylvania with flights to Chicago and Washington. Convenient alternative for Jamestown area travelers.",
      flightUrl: "https://www.erieairport.org/",
      flightLabel: "Erie Airport",
      featured: false,
    },
    {
      code: "ROC",
      name: "Greater Rochester International Airport",
      distance: "~130 miles from Jamestown",
      address: "1200 Brooks Ave, Rochester, NY 14624",
      note: "Upstate New York airport with flights to major U.S. hubs. Alternative for Jamestown area travelers.",
      flightUrl: "https://www.flyrga.com/",
      flightLabel: "Rochester Airport",
      featured: false,
    },
  ],
  services: [
    {
      icon: "ri-passport-line",
      title: "Emergency Passport",
      description: "For Jamestown travelers with urgent departures within 24 hours to 2 weeks. Direct New York Passport Agency submission with dedicated courier handling.",
      bullets: ["Processing as fast as 24 hours", "Dedicated agent assigned to your case", "Daily status updates"],
      badge: "Fastest",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Fast renewal for Jamestown residents with a valid passport issued within the last 15 years at age 16 or older.",
      bullets: ["3-5 day or 10-day options available", "No acceptance clerk visit required", "Secure overnight document return"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-user-add-line",
      title: "New Passport",
      description: "First-time passport application assistance for Jamestown residents with step-by-step guidance through the acceptance clerk process.",
      bullets: ["Complete application review before submission", "Acceptance clerk appointment guidance", "3-5 day or 10-day processing options"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alarm-warning-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement service for Jamestown residents who have lost their passport or had it stolen.",
      bullets: ["DS-64 form guidance included", "Replacement in 3-5 days or 10 days", "Acceptance clerk visit required"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 in Jamestown, with parental consent guidance and acceptance clerk support.",
      bullets: ["Parental consent documentation review", "Both parents present or notarized consent", "3-5 day or 10-day processing available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal name change for Jamestown residents.",
      bullets: ["Marriage certificate or court order review", "Name change in 3-5 days or 10 days", "No clerk visit for most renewals"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for Jamestown travelers with immediate departure needs from Buffalo Niagara International Airport." },
    { name: "Passport Renewal", description: "Fast passport renewal for Jamestown residents with a recent valid passport." },
    { name: "New Passport", description: "First-time passport application assistance for Jamestown residents." },
    { name: "Lost or Stolen Passport", description: "Passport replacement for Jamestown residents who have lost their passport." },
    { name: "Child Passport", description: "Passport services for minors under 16 in Jamestown and Chautauqua County." },
    { name: "Name Change", description: "Passport name change service after marriage, divorce, or legal name change in Jamestown." },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Photos must be 2\"x2\" with a plain white or off-white background. Many Jamestown travelers get rejected at the acceptance clerk because their photos don't meet strict State Department specs.",
    },
    {
      icon: "ri-file-list-3-line",
      title: "Missing or Incorrect Forms",
      description: "Using the wrong form (DS-11 vs DS-82) or missing required fields can cause weeks of delays. We review every form before submission.",
    },
    {
      icon: "ri-calendar-line",
      title: "Waiting Too Long to Start",
      description: "Standard processing takes 8-11 weeks. Many Jamestown travelers wait until the last minute, leaving no buffer for problems.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Incorrect Payment Amount",
      description: "Government fees change frequently. Using an outdated check or wrong amount will cause your application to be returned.",
    },
    {
      icon: "ri-shield-line",
      title: "Damaged or Expired ID",
      description: "Your driver's license or state ID must be valid and unexpired. Many applicants don't realize their ID is about to expire until it's too late.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For child passports, both parents must appear or provide notarized consent. Missing documentation is the #1 reason child applications are delayed.",
    },
  ],
  steps: [
    {
      number: "01",
      icon: "ri-file-list-3-line",
      title: "Complete Your Application",
      description: "Fill out your passport application online or over the phone with our Jamestown team. We review everything for accuracy.",
    },
    {
      number: "02",
      icon: "ri-upload-cloud-line",
      title: "Send Us Your Documents",
      description: "Ship your documents via overnight courier to our secure processing center. We confirm receipt and begin review immediately.",
    },
    {
      number: "03",
      icon: "ri-search-line",
      title: "We Review Everything",
      description: "Our agents verify your forms, photos, and supporting documents meet all State Department requirements — no surprises.",
    },
    {
      number: "04",
      icon: "ri-shield-check-line",
      title: "Courier Submission",
      description: "As a registered U.S. Department of State courier, we submit your application directly to the New York Passport Agency.",
    },
    {
      number: "05",
      icon: "ri-passport-line",
      title: "Receive Your Passport",
      description: "Your passport is delivered securely to your Jamestown address. We provide tracking and daily status updates throughout.",
    },
  ],
  processingOptions: [
    {
      speed: "8-11",
      unit: "weeks",
      label: "Standard Processing",
      tag: "Post Office",
      tagColor: "bg-gray-200 text-gray-600",
      features: [
        "Mail-in application",
        "No expedited handling",
        "No dedicated agent",
        "No phone or email contact for your case",
        "Updates only by physical mail letter",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "10",
      unit: "business days",
      label: "Smart Saver",
      tag: "Fast Passport Center",
      tagColor: "bg-green-100 text-green-700",
      features: [
        "Secure overnight shipping included",
        "Document review before submission",
        "Dedicated agent assigned",
        "Daily status updates",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "3-5",
      unit: "business days",
      label: "Expedited Processing",
      tag: "Recommended",
      tagColor: "bg-[#1A365D] text-white",
      features: [
        "Secure overnight shipping included",
        "Document review before submission",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "24",
      unit: "hours",
      label: "Emergency Processing",
      tag: "Life or Death",
      tagColor: "bg-red-100 text-red-600",
      features: [
        "For documented life-or-death emergencies only",
        "Requires proof of emergency travel",
        "Strictly for documented life-or-death emergencies",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Must book weeks in advance", fpc: "No appointment needed — we handle agency access" },
    { feature: "Processing Speed", agency: "1-2 business days (if you get an appointment)", fpc: "As fast as 3-5 days or 24 hours for emergencies" },
    { feature: "Document Review", agency: "No pre-check — one mistake means restart", fpc: "Complete review before submission — we catch errors" },
    { feature: "Travel Proof", agency: "Requires printed itinerary with confirmed travel within 2 weeks", fpc: "Flexible documentation requirements" },
    { feature: "Updates", agency: "No phone or email support — only mail updates", fpc: "Daily status updates via phone and email" },
    { feature: "Guarantee", agency: "No guarantee of appointment or same-day processing", fpc: "Reserved agency slots with predictable processing" },
  ],
  stickyNavLinks: [
    { label: "Processing Options", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  internalLinks: [
    { name: "New York City", route: "/cities/new-york-city" },
    { name: "Brooklyn", route: "/cities/brooklyn" },
    { name: "Queens", route: "/cities/queens" },
    { name: "Buffalo", route: "/cities/buffalo" },
    { name: "Albany", route: "/cities/albany-ny" },
    { name: "Syracuse", route: "/cities/syracuse" },
    { name: "Rochester", route: "/cities/rochester" },
    { name: "Yonkers", route: "/cities/yonkers" },
    { name: "The Bronx", route: "/cities/the-bronx" },
    { name: "Staten Island", route: "/cities/staten-island" },
    { name: "Long Island", route: "/cities/long-island" },
    { name: "Binghamton", route: "/cities/binghamton" },
    { name: "Elmira", route: "/cities/elmira" },
    { name: "Ithaca", route: "/cities/ithaca" },
    { name: "Corning", route: "/cities/corning" },
    { name: "New York State", route: "/states/new-york" },
  ],
  fpcOfficeNote:
    "Fast Passport Center serves Jamestown and all of Chautauqua County as a remote courier service. We do not have a physical office in Jamestown, but our secure overnight shipping network ensures your documents reach our processing center quickly and safely.",
  fpcOfficeAddress: "347 Fifth Avenue, New York, NY 10016",
  fpcOfficeDistance: "Remote courier service — Jamestown area",
  serviceAreaIntro:
    "Fast Passport Center provides expedited passport services to Jamestown and all of Chautauqua County. From the Furniture Capital to the shores of Lake Erie, from Dunkirk to Fredonia — we serve western New York with the same fast, reliable processing.",
  nearbyCitiesIntro:
    "We proudly serve Jamestown and all surrounding communities across Chautauqua County and the Lake Erie region. Whether you're in Dunkirk, Fredonia, or Westfield, our expedited passport services are available to you.",
  howItWorksIntro:
    "Our Jamestown customers follow a simple, proven process to get their passports fast. No agency visits, no waiting in lines, no guessing.",
  mistakesIntro:
    "These are the most common mistakes Jamestown travelers make when applying for an expedited passport. Avoiding them saves weeks of delays.",
  testimonialsIntro:
    "Jamestown and western New York travelers trust Fast Passport Center for their urgent passport needs. Here's what they say about our service.",
  faqIntro:
    "Common questions about emergency and expedited passport services in Jamestown. If you don't see your question here, call us at 877-253-0084.",
  statePageRoute: "/states/new-york",
  statePageName: "New York Passport Services",
  dmvWebsite: "https://dmv.ny.gov",
  dmvLabel: "New York DMV — Official Website",
};

export default jamestownConfig;